<script setup lang="ts">
  import BottomNavigation from "@/components/organisms/BottomNavigation.vue";
</script>

<template>
  <main :class="$style.root">
    <slot></slot>
  </main>
  <BottomNavigation />
</template>

<style lang="scss" module>
  .root {
    width: 100%;
    max-width: 1280px;
    height: 100%;
    margin: 0 auto;

    display: flex;

    overflow: hidden;
  }
</style>
